<template>
  <Content title="客户这样评价我们">
    <div id="commentCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
      <div class="carousel-inner h-100">
        <div class="carousel-item comment-item active">
          <div class="w-100 letter-cover-m">
            <div class="letter-title">表扬信</div>
            <div class="mb-2">深圳市特航航空服务有限公司：</div>
            <div>
              行程（香港-河内）如果订早班机，纠结如何过港（深圳有没有早船到达，提前一天海关让不让过），客服不断给客户寻找最优出行方案，并将了解到的珠三角以及香港码头的出入境相关信息及时推送给客户，最终预订成功。但是乘机当天航班取消，客服第一时间通知客户后，又重新给客户寻找出行方案，最后预订香港-曼谷-河内，让客户顺利出行。此次沟通中，客户多次表扬该客服服务周到、敬业，并表示等疫情过去后要请其吃饭。
            </div>
            <div class="letter-sign">
              <div>客户-XXX集团</div>
            </div>
          </div>
        </div>
        <div class="carousel-item comment-item">
          <div class="w-100 letter-cover-m">
            <div class="letter-title">表扬信</div>
            <div class="mb-2">尊敬的特航领导：</div>
            <div>
              见信好。贵公司赵彩霞同志自2013年以来为我司担任机票预订工作，她勤劳刻苦、踏实肯干，细心又耐心的为我们各类差旅行程提供保障，她把工作当成了一份职责和成就自己的机会，坚信只要用心就一定能做好，她的努力与付出获得了公司领导同事的一致好评。
              彩霞不仅是一名好同事，也是一位好伙伴，她积极工作认真生活的态度
              ，与人为善的良好品德感染着每一位身边的同事，我们很高兴能在这晨与彩霞相知相识，一起奋斗，共同努力……
            </div>
            <div class="letter-sign">
              <div>XX 人力行政部</div>
              <div>2019年1月28</div>
            </div>
          </div>
        </div>
        <div class="carousel-item comment-item">
          <div class="w-100 letter-cover-m">
            <div class="letter-title">表扬信</div>
            <div class="mb-2">深圳市特航航空服务有限公司：</div>
            <div>
              你们好！首先非常感谢贵司对我校国际合作工作的大力支持!自2016年至今，贵司为我校提供了机票、住宿、城市间交通等多方面的出访服务保障与支撑，为我校国际合作工作提供了重要的保障。贵司王川川先生常年对接我部，协调跟进学校主要的出访服务保障，服务状态佳、工作效率高、响应及时。由于国际合作工作常常有时差，工作中不可避免在中国正常工作时间以外开展工作，王川川先生加班加点，任劳任怨，积极响应我校工作人员在境外时的出访工作需求，为我校出访工作顺利进行提供了重要的支持。<br />
              衷心感谢包括贵司王川川先生在内的工作人员对我校国际合作工作的支持……
            </div>
            <div class="letter-sign">
              <div>XX国际合作部</div>
              <div>2020年1月8日</div>
            </div>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#commentCarousel" role="button" data-slide="prev">
        <span class="carousel-preview-btn" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#commentCarousel" role="button" data-slide="next">
        <span class="carousel-next-btn" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'MobileComment',
  components: { Content },
  setup() {},
}
</script>

<style lang="scss" scoped>
.letter-cover-m {
  background-image: url('/images/mobile/letter-paper.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 428px;
  padding: 15px 35px;
  font-size: 12px;
}

.letter-title {
  font-size: 13px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 16px;
}

.letter-sign {
  position: absolute;
  bottom: 56px;
}

.carousel-control-prev,
.carousel-control-next {
  width: 8%;
}

.carousel-control-prev {
  left: -15px;
}
.carousel-control-next {
  right: -15px;
}
</style>
